import { GET_PARCHI_HOST } from "apis";
import { serializeErrorForTracking, track } from "../../utils/tracking";
import fetchWrapper from "apis/src/fetch-client";

async function getPastSAOfPatient({
  patientId,
}: {
  patientId: string;
}): Promise<{
  success: boolean;
  data?: {
    conversationid: string;
    created_at: string;
    wflow_wfid: string;
  }[];
}> {
  try {
    const response = await fetchWrapper(
      `${GET_PARCHI_HOST()}/app/get/sa-by-patient/${patientId}`,
      {
        method: "GET",
        redirect: "follow",
        mode: "cors",
        credentials: "include",
      }
    );
    return await response.json();
  } catch (error: any) {
    track(`GET_PAST_SA_OF_PATIENT_FAILED`, {
      on: "getPastSAOfPatient",
      what: serializeErrorForTracking(error),
      stack: error?.stack,
      patientId
    });
    console.error(error);
    return {
      success: false,
    };
  }
}

export default getPastSAOfPatient;
